<template>
    <el-dialog title="输入示例" width="50%" :visible.sync="visible">
        <pre class="pre-text">
        项目标题
        感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！【欢迎语】

        您经常创建什么类型的项目？【单选题】
        问卷调研
        满意度调查
        投票评选
        表单报名
        测评考试

        您使用过问卷网哪款应用？【多选题】
        抽奖
        配额
        投票墙
        微信红包
        微信签到
        自定义域名

        请填写您的问题和建议【填空题】
        </pre>
        <slot/>
    </el-dialog>
</template>

<script>
export default {
    name: "example",
    data () {
        return {
            visible: false
        }
    },
    methods: {
        open () {
            this.visible = true
        },
        close () {
            this.visible = false
        }
    }
}
</script>

<style scoped>
.pre-text {
    font-size: 16px;
    font-weight: 400;
}
</style>
